<template>
  <div class="bookClassDetail">
    <!-- 内容层开始 -->
    <div class="box">
      <div class="box_title">
        <van-image class="img" :src="detail.cover" fit="fill"></van-image>
      </div>
      <div class="box_content">
        <div class="title">{{ detail.name }} <span class="isBuy" v-if="detail.isBuy">已购</span></div>
        <div class="sku"><div class="tip" v-for="(item, index) in detail.labels" :key="index">{{ item }}</div></div>
        <div class="message">简介：{{ detail.brief }}</div>
        <div v-if="detail.adImg != null && detail.adImg != ''">
          <img style="border-radius: 5px" :src="detail.adImg" @click="openAdUrl">
        </div>
        <div class="bottom" style="margin-top: 10px">
          <div class="price" >
            <template v-if="!detail.free">
              ￥<span class="big">{{ detail.price }}</span>
            </template>
            <template v-else>
              <span class="big">免费</span>
            </template>
          </div>
          <div class="text">共{{ detail.chapterCount }}章{{ detail.annexCount }}节 | {{ detail.learnCount }}人已学</div>
        </div>
      </div>
      <div class="box_bottom"></div>
    </div>
    <!-- 内容层结束 -->
    <van-tabs
      v-model="tab.active"
      class="section section_padding"
      :swipeable="true"
      :animated="true"
    >
      <van-tab title="课程章节">
        <div class="section_01">
          <!-- 进度条开始 -->
          <div class="progress">
            <span class="text">当前学习进度</span>
            <div class="pro">
              <div class="currentPro"  :style="{'width':`${426*(detail.progress*1/100)*$utils.ratio}px`}"></div>
            </div>
            <span class="percentage">{{ detail.progress }}%</span>
          </div>
          <!-- 进度条结束 -->

          <!-- 章节选择开始 -->
          <Collapse v-model="tab.activeNames" :border="false">
            <CollapseItem :name="index" :border="false" v-for="(item, index) in detail.chapters" :key="index">
              <template #title>
                <div class="title">
                  <div class="name">{{ item.name }}<span class="look look_01" v-if="item.isBuy && item.aloneSale && !detail.free">已购</span></div>
                  <div class="price" v-if="!detail.free && !item.isBuy && item.aloneSale">￥{{ item.price }}</div>
                </div>
              </template>
              <template #default>
                <ul class="list">
                  <template  v-if="item.annexes.length===0 && item.exercises.length===0">
                    <li class="list_list">
                      暂无内容
                    </li>
                  </template>
                  <template v-else>
                    <li class="list_item" v-for="(cliItem) in item.annexes" :key="cliItem.id" @click="jumpTo(cliItem,'out','annexes')">
                      <div class="left">
                        <div :class="`img ${icon[cliItem.fileType]}`" fit="cover"></div>
                        <div>
                          <span>{{ cliItem.name }}</span>
                          <!-- <span class="look look_01" v-if="index===0">试看</span>
                          <span class="look look_02" v-if="index===1">免费</span> -->
                          <span class="look look_01" v-if="cliItem.isBuy && cliItem.aloneSale && !detail.free">已购</span>
                          <template v-if="!cliItem.isBuy && cliItem.isTryView && !detail.isFree">
                            <span class="look look_01"  v-if="cliItem.fileType === 2">试听</span>
                            <span class="look look_01" v-else>可试看</span>
                          </template>
                        </div>
                      </div>
                      <div class="right"> <span v-if="!cliItem.isBuy && cliItem.aloneSale && !detail.free">￥{{ cliItem.price }}</span></div>
                    </li>
                    <li class="list_item" v-for="(cliItem) in item.exercises" :key="cliItem.id" @click="jumpTo(cliItem,'out','exercises')">
                      <div class="left">
                        <van-image class="img" :src="require('@/assets/images/book/icon_09.png')" fit="cover"></van-image>
                        {{ cliItem.name }}({{ cliItem.type === 1 ? '练习题':'测试题' }})
                        <!-- <span class="look look_01" v-if="index===0">试看</span>
                        <span class="look look_02" v-if="index===1">免费</span> -->
                        <span class="look look_01" v-if="cliItem.isBuy && cliItem.aloneSale && !detail.free">已购</span>
                      </div>
                      <div class="right"> <span v-if="!cliItem.isBuy && cliItem.aloneSale && !detail.free">￥{{ cliItem.price }}</span></div>
                    </li>
                </template>
                </ul>
              </template>
            </CollapseItem>
          </Collapse>
          <!-- 章节选择结束 -->
        </div>
      </van-tab>
      <van-tab title="课程详情">
        <!-- 课程详情开始 -->
        <div class="section_02 rich-text" v-html="detail.content">
          <!-- <div class="box"
            v-for="(item,index) in 3"
            :key="index"
            @click="$router.push({name:'SearchDetail',query:{id:1}})"
          >
            <div class="box_title">
              <van-image :src="require('@/assets/images/book/img_bg_03.png')" class="img"></van-image>
            </div>
            <div class="box_content content_1">
              <div class="title">关于2021年开展首届广东省中小学思政课 “新...</div>
            </div>
          </div> -->
        </div>
        <!-- 课程详情结束 -->

      </van-tab>
      <van-tab title="精选评论">
        <Empty
          v-if="courseDetail.totalCount === 0"
        ></Empty>
        <van-list
          v-else
          v-model="courseDetail.loading"
          :finished="courseDetail.finished"
          finished-text="没有更多"
          @load="getCourseDetail()"
        >
          <div class="section_03">
            <div class="box" v-for="(item,index) in courseDetail.list" :key="index">
              <div class="box_content">
                <div class="top">
                  <div class="box_item">
                    <div class="left">
                      <van-image class="img" :src="item.avatar || require('@/assets/images/avatar_default_01.png')"></van-image>
                      <div></div>
                    </div>
                    <div class="right">
                      <div class="text">
                        <div class="st1">{{ item.name }}</div>
                        <div class="st2">{{ item.createTime | formatDate('yyyy-MM-dd') }}</div>
                      </div>
                      <div class="info">{{ item.chapterName }}</div>
                    </div>
                    <p class="p_text">{{ item.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <template >

        </template>
      </van-tab>
    </van-tabs>
    <!-- 底部列表开始 -->
    <div class="fixTop fixed">
      <div class="fixed" >
        <div class="box">
          <div class="box_left">
            <ul class="list">
              <li class="list_item"
                v-for="(item, index) in operations"
                :key="index"
                @click="itemClick(index)"
              >
                <!-- <van-image class="img" :src="item.src"></van-image>
                <van-image class="img" :src="item.active"></van-image> -->
                <i class="icon" :class="{'active': detail.isCollected}"></i>
                <div class="text" v-if="!detail.isCollected">{{ item.text }}</div>
                <div class="text" v-else>{{ item.activeCollect }}</div>
              </li>
            </ul>
          </div>
          <div class="box_right" v-if="detail">
            <template v-if="detail.free || detail.isBuy">
              <!-- <div class="btn btn_01" @click="toLearn"></div> -->
              <span></span>
            </template>
            <!-- 没买 不是 免费 则需要购买 -->
            <template v-else>
              <div class="btn btn_02" @click="popupBuy = true">立即购买</div>
            </template>
          </div>
        </div>
        <div class="iphoneX"></div>
      </div>
    </div>

    <!-- 底部列表结束 -->

    <!-- 购买弹层开始 -->
    <van-popup
      v-model="popupBuy"
      position="bottom"
      :style="{ height: '60%' }"
      :round="true"
    >
      <div class="close" v-show="popupBuy">
        <div class="left"></div>
        <div class="center"></div>
        <div class="right" @click="popupBuy = false"><van-image class="img" :src="require('@/assets/images/icon_del_02.png')"></van-image></div>
      </div>
      <div class="section">
        <div class="popup">
          <!-- 手册选择开始 -->
          <div
            v-for="(item, index) in detail.chapters"
            :key="index"
            @click="jumpTo(item,'int');type = 1"
            v-show="!item.isBuy && !detail.free"
          >
            <div class="title"
              :class="{'selectActive':detail.selectId === item.id}"
            >
              <div class="left">
                <template v-if="!item.isBuy && item.aloneSale">
                  <i class="icon icon_01" v-show="detail.selectId !== item.id"></i>
                  <i class="icon icon_02" v-show="detail.selectId === item.id"></i>
                </template>
                <div class="name">
                  {{ item.name }}
                </div>
              </div>
              <div class="price">￥{{ item.price }}</div>
            </div>
            <ul class="list">
              <!-- 章节没有内容 -->
              <template  v-if="item.annexes.length===0 && item.exercises.length===0">
                <li class="list_list">
                  暂无内容
                </li>
              </template>
              <!-- 章节没有内容 -->

              <template v-else>
                <li
                  class="list_item list_content"
                  v-for="(cliItem) in item.annexes"
                  :key="cliItem.id"
                  @click.stop.prevent="jumpTo(cliItem,'int','annexes');type = 2"
                  :class="{'selectActive':detail.selectId === cliItem.id || detail.selectId === item.id}"
                  v-show="!cliItem.isBuy && !detail.free"
                >
                  <div class="left">
                    <template v-if="!cliItem.isBuy && cliItem.aloneSale">
                      <i class="icon icon_01" v-show="detail.selectId !== cliItem.id && detail.selectId !== item.id"></i>
                      <i class="icon icon_02" v-show="detail.selectId === cliItem.id || detail.selectId === item.id"></i>
                    </template>
                    <div :class="`img ${icon[cliItem.fileType]}`" fit="cover"></div>
                    <div>
                      <span>{{ cliItem.name }}</span>
                      <span class="look look_01" v-if="cliItem.isBuy && cliItem.aloneSale && !detail.free">已购</span>
                      <template v-if="!cliItem.isBuy && cliItem.isTryView && !detail.isFree">
                        <span class="look look_01"  v-if="cliItem.fileType === 2">试听</span>
                        <span class="look look_01"  v-else-if="cliItem.fileType === 3">可试看</span>
                      </template>
                    </div>
                  </div>
                  <div class="right" v-if="!cliItem.isBuy && cliItem.aloneSale && !detail.free">￥{{ cliItem.price }}</div>
                </li>
                <li class="list_item list_content"
                  v-for="(cliItem) in item.exercises"
                  :key="cliItem.id"
                  @click.stop.prevent="jumpTo(cliItem,'int');type = 3"
                  :class="{'selectActive':detail.selectId === cliItem.id  || detail.selectId === item.id}"
                  v-show="!cliItem.isBuy && !detail.free"
                >
                  <div class="left">
                    <template v-if="!cliItem.isBuy && cliItem.aloneSale">
                      <i class="icon icon_01" v-show="detail.selectId !== cliItem.id && detail.selectId !== item.id"></i>
                      <i class="icon icon_02" v-show="detail.selectId === cliItem.id || detail.selectId === item.id"></i>
                    </template>
                    <van-image class="img" :src="require('@/assets/images/book/icon_09.png')" fit="cover"></van-image>
                    {{ cliItem.name }}({{ cliItem.type === 1 ? '练习题':'测试题' }})
                    <!-- <span class="look look_01" v-if="index===0">试看</span>
                    <span class="look look_02" v-if="index===1">免费</span> -->
                    <span class="look look_01" v-if="cliItem.isBuy && cliItem.aloneSale && !detail.free">已购</span>
                  </div>
                  <div class="right"> <span v-if="!cliItem.isBuy && cliItem.aloneSale && !detail.free > 0">￥{{ cliItem.price }}</span></div>
                </li>
              </template>
            </ul>
          </div>
          <!-- 手册选择结束 -->
        </div>
      </div>

      <div v-show="popupBuy" class="fixed">
        <div class="box popupFixed" >
          <div class="box_left">
            <div class="fixBtnL" @click="toBuy('All');">
              <div class="left">
                <p class="p">购买全部</p>
                <p class="p2">共{{ detail.chapterCount }}章{{ detail.annexCount }}节</p>
              </div>
              <div class="right">￥{{ detail.price }}</div>
            </div>
          </div>
          <div class="box_right">
            <div class="fixBtnR"
              :class="{active:detail.selectId!==''}"
            >
              <template v-if="detail.selectId === ''">
                选择购买
              </template>
              <template v-else>
                <span @click="toBuy('select')">选择购买 ￥{{ selectPrice }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 购买弹层结束 -->
  </div>
</template>

<script>
import { Collapse, CollapseItem } from 'vant';
export default {
  props: {
  },
  components: {
    Collapse,
    CollapseItem
  },
  data () {
    return {
      id: '',
      active: 0,
      // 课程章节使用
      tab: {
        active: 0,
        activeNames: [0]
      },

      /* 收藏操作 */
      operations: [
        {
          src: require('@/assets/images/book/icon_star_01.png'),
          active: require('@/assets/images/book/icon_star_02.png'),
          text: '收藏',
          activeCollect: '已收藏'
        }
      ],

      /* 是否收藏 */
      show: false,

      /* 当前页面详情信息 */
      detail: {},

      /* 图标展示 */
      icon: {
        0: 'img_0', // 富文本
        2: 'img_2', // 音频 1
        3: 'img_3', // 视频
        4: 'img_4', // 压缩包
        5: 'img_5', // ppt
        6: 'img_6', // pdf
        7: 'img_7', // word
        8: 'img_8', // excel
        9: 'img_9', // 其他
        10: 'img_10' // 图片
      },

      /* 课程评论详情 */
      courseDetail: {
        loading: false,
        finished: false,
        totalCount: '',
        pageNo: 1,
        pageSize: 10,
        list: []
      },

      api: {
        0: 'course',
        1: 'lesson'
      },

      popupBuy: false, // 购买弹层

      type: 0 // 0(课程)，1(章节)，2(资源附件)，3(练习题测试题)
    };
  },
  computed: {

    /* 计算选则课程后的价格 */
    selectPrice () {
      const { detail } = this;
      return parseFloat(detail.selectPrice * 100 / 100).toFixed(2);
    }
  },
  watch: {

  },
  created () {

  },
  async mounted () {
    let { $route: { query: { id, active } } } = this;
    // this.id = id
    this.id = id || '';
    this.active = active || 0;
    await this.getDetail();
  },
  methods: {

    /* 初始化评论列表 */
    init () {
      this.courseDetail = {
        loading: true,
        finished: false,
        totalCount: '',
        pageNo: 1,
        pageSize: 10,
        list: []
      };

      this.getCourseDetail();
    },

    /* 获取详情页信息 */
    async getDetail () {
      const { id, $http, $utils, $router, api, active } = this;

      if (id) {
        $http.get(`${api[active]}/detail`, {
          params: {
            id
          },
          showLoading: true,
          loadingText: '加载中...',
          customError: true
        }).then(({ data }) => {
          console.log("课程详情",data)

          this.$set(data, 'selectId', '');
          this.$set(data, 'selectPrice', 0);
          this.$nextTick((_v) => {
            this.detail = data || {};
            this.$wxShare({
              // url: window.href, // 网址，默认使用 window.location.href
              title: data.brief, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
              desc: data.name || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
              imgUrl: data.cover // 图片, 默认取网页中第一个img标签
            });
          });
        }).catch((err) => {
          let { data: { result, msg } } = err;
          // 没有登录
          if (result === -2) {
            $utils.failToast({
              message: msg,
              onClose: () => {
                $router.push({
                  name: 'Login'
                });
              }
            });
          } else if (result === -4) {
            $utils.failToast({
              message: '没有权限查看，请选择其他课程',
              onClose: () => {
                $router.go(-1);
              }
            });
          }
        });
      }
    },

    /* 获取课程评论信息 */
    getCourseDetail () {
      const { $http, id, courseDetail: { pageNo, pageSize } } = this;
      let { courseDetail } = this;
      $http.get('comment/list', {
        params: {
          id,
          pageNo,
          pageSize
        }
      }).then((res) => {
        const { isHasNext, nextPage, totalCount, result } = res.data.page || {};
        courseDetail.finished = !isHasNext;
        courseDetail.loading = false;
        courseDetail.list.push(...result);
        courseDetail.pageNo = nextPage;
        courseDetail.totalCount = totalCount;
        this.courseDetail = courseDetail;
      });
    },

    /* 收藏课程 */
    itemClick (index) {
      let { $utils, $http, id, detail, api, active } = this;
      if (this.$goToLogin()) {
        $http.post(`${api[active]}/collect`, {
          id
        }, {
          showLoading: true,
          loadingText: '加载中...'
        }).then((res) => {
          if (res.result === 1) {
            detail.isCollected = !detail.isCollected;
            detail.isCollected ? $utils.toast('收藏成功') : $utils.toast('取消收藏');
          }
        });
      }
    },

    /* 练习题/测试题/视频、音频、图片、word、excel、ppt、pdf等 */
    jumpTo (item, key, source = '') {
      console.log("跳转++++")
      const { $utils, detail, $router, active } = this;
      // fileType  2:mp3 3:mp4 10:图片 8:xlsx
      /* 免费/买了课程 情况  */
      if (detail.free || detail.isBuy) {
        // 资源文件
        if (source === 'annexes') {
          $router.push({
            name: 'MediaDetail',
            query: {
              active,
              courseId: detail.id,
              annexId: item.id
            }
          });
        } else {

          /* 测试题 */
          if (item.type === 2 && item.isSubmit) {
            // 测试题 且提交了的情况下
            $router.push({ name: 'BookPracticeResult', query: { id: item.id } });
          } else {
            // 测试题或者练习题 且没有提交了的情况下
            $router.push({ name: 'BookPractice', query: { id: item.id } });
          }
        }
      } else {

        /* 没买课程、且不是课程免费 */

        /* 如果单个项是试看或者已买 */
        if (item.isTryView || item.isBuy) {

          if (source === 'annexes') {

            if (key === 'out') {
              $router.push({
                name: 'MediaDetail',
                query: {
                  active,
                  courseId: detail.id,
                  annexId: item.id
                }
              });
            } else {
              if (item.aloneSale) {
                detail.selectId = item.id;
                detail.selectPrice = item.price;
              } else {
                $utils.toast('该内容不允许单独购买，请购买课程');
              }
            }

          } else if (source === 'exercises') {

            /* 测试题 */
            if (item.type === 2 && item.isSubmit) {
            // 测试题 且提交了的情况下
              $router.push({ name: 'BookPracticeResult', query: { id: item.id } });
            } else {
            // 测试题或者练习题 且没有提交了的情况下
              $router.push({ name: 'BookPractice', query: { id: item.id } });
            }
          }

        } else {
          if (item.aloneSale) {
            if (key === 'out') {
              this.popupBuy = true;
            } else {

              /*
              多选情况下的代码 需要将selectId变成数组 []

              选中后 如果不包含选中的值 则添加进数组里 并且将价格提交
              if (!detail.selectId.includes(item.id)) {
                detail.selectId = item.id;
                detail.selectPrice += item.price;
              } else {
              // 如果包含选中的值 则从数组删除 并且将对应价格减去
                detail.selectId = detail.selectId.filter((selectItemId) => selectItemId !== item.id);
                detail.selectPrice -= item.price;
              }
            */

              detail.selectId = item.id;
              detail.selectPrice = item.price;
            }
          } else {
            $utils.toast('该内容不允许单独购买，请购买课程');
          }

          return false;
        }
      }

    },

    /* 去学习 */
    toLearn () {
      this.$router.push({
        name: 'MediaDetail'
      });
    },

    /* 购买 */
    toBuy (key) {
      let { $router, detail, active, type } = this;
      let id;
      if (key === 'All') {
        type = 0;
        id = detail.id;
      } else {
        id = detail.selectId;
      }
      $router.push({
        name: 'BookBuy',
        query: {
          id,
          active,
          type
        }
      });
    },
    openAdUrl(){
      console.log("++",this.detail.adUrl)
      // 打开广告url
      if (this.detail.adUrl != null && this.detail.adUrl != ''){
        window.open(this.detail.adUrl)
      }
    },
  }
};
</script>

<style scoped lang="less">
  .bookClassDetail{

    .box {
      .box_title{
        width: 100%;
        .img{
          width: 100%;
          height: 500px;
        }
      }
      .box_content{
        background: #FFFFFF;
        border-radius: 28px 28px 0px 0px;
        padding: 56px 28px;
        position: relative;
        top: -18px;
        border-bottom: 20px solid #F9FAFC;
        .title{
          font-size: 36px;
          font-weight: bold;
          line-height: 56px;
          color: #333444;
          margin-bottom: 56px;
          .isBuy{
            width: 76px;
            height: 36px;
            border: 2px solid #5FA9FF;
            border-radius: 8px;
            display: inline-block;
            font-size: 20px;
            line-height: 36px;
            color: #5FA9FF;
            text-align: center;
            position: relative;
            top: -4px;
            margin-left: 4px;
          }
        }
        .sku{
          display: flex;
          flex-wrap: wrap;
          .tip{
            width: 128px;
            height: 46px;
            background: #F0F7FF;
            border: 2px solid #5FA9FF;
            border-radius: 40px;
            font-size: 24px;
            line-height: 46px;
            color: #5FA9FF;
            text-align: center;
            margin-bottom: 28px;
            margin-right: 18px;
            &:last-child{
              margin-right: 0;
            }
          }
        }
        .message{
          font-size: 26px;
          line-height: 48px;
          color: #67677A;
          margin-bottom: 52px;
        }
        .bottom{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .price{
            font-size: 28px;
            font-weight: bold;
            color: #FF485D;
            .big{
              font-size: 40px;
            }
          }
          .text{
            font-size: 28px;
            line-height: 60px;
            color: #999999;
          }
          .btn{
            border-radius: 36px;
            font-size: 26px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            padding: 14px 38px;
            &.btn_01{
              background: linear-gradient(270deg, #FF7643 0%, #FF5A7A 100%);
              box-shadow: 0px 6px 12px rgba(255, 103, 97, 0.2);
            }
            &.btn_02{
              background: #DDDEE6;
            }
          }
        }
      }
    }

    .section{
      .title{
        display: flex;
        align-items: center;
        font-size: 32px;
        font-weight: bold;
        color: #333444;
        width: 100%;
        justify-content: space-between;
        &::before{
          display: none !important;
        }
        .name{
          display: flex;
          align-items: center;
          &::before{
            content: "";
            display: inline-block;
            border-radius: 4px;
            width: 8px;
            height: 32px;
            margin-right: 20px;
            background: #5FA9FF;
          }
        }
        .price{
          font-size: 28px;
          font-weight: bold;
          color: #FF485D;
          margin-right: 20px;
        }
      }
      .list{
        display: flex;
        flex-direction: column;
        .list_item{
          display: flex;
          align-items: center;
          font-size: 26px;
          line-height: 48px;
          color: #67677A;
          justify-content: space-between;
          margin-bottom: 40px;
          &.list_content{
            line-height: inherit;
            padding: 20px 54px 20px 28px;
            margin-bottom: 0;
          }
          .left{
            display: flex;
            align-items: center;
          }
          .right{
            font-size: 26px;
            color: #FF485D;
            flex-shrink: 0;
            padding-left: 15px;
          }
          &:last-child{
            margin-bottom: 0;
          }
          .img{
            width: 32px;
            height: 32px;
            margin-right: 20px;
            background-repeat: no-repeat;
            background-size: contain;
            &.img_0{
              background-image: url('~@/assets/images/book/icon_09.png');
            }
            &.img_2{
              background-image: url('~@/assets/images/book/icon_08.png');
            }
            &.img_3{
              background-image: url('~@/assets/images/book/icon_04.png');
            }
            &.img_4{
              background-image: url('~@/assets/images/book/icon_14.png');
            }
            &.img_5{
              background-image: url('~@/assets/images/book/icon_13.png');
            }
            &.img_6{
              background-image: url('~@/assets/images/book/icon_15.png');
            }
            &.img_7{
              background-image: url('~@/assets/images/book/icon_05.png');
            }
            &.img_8{
              background-image: url('~@/assets/images/book/icon_06.png');
            }
            &.img_9{
              background-image: url('~@/assets/images/book/icon_09.png');
            }
            &.img_10{
              background-image: url('~@/assets/images/book/icon_07.png');
            }
          }
        }
        .list_list{
          font-size: 26px;
          padding: 0 28px;
          color: #969799;
        }
      }
      .look{
        width: 76px;
        height: 36px;
        border-radius: 8px;
        font-size: 20px;
        line-height: 36px;
        text-align: center;
        margin-left: 20px;
        padding: 0 10px;
        &.look_01{
          border: 2px solid #5FA9FF;
          color: #5FA9FF;
        }
        &.look_02{
          border: 2px solid #FC485D;
          color: #FC485D;
        }
      }
      &.section_padding{
        padding: 0 28px 150px;
        .section_01{
          .list{
            padding-right: 60px;
          }
        }
      }
      .section_01{
        margin-bottom: 16px;
        margin-top: 40px;
        .progress{
          margin-bottom: 40px;
          display: flex;
          align-items: center;
          .text{
            font-size: 26px;
            line-height: 48px;
            color: #67677A;
            margin-right: 28px;
          }
          .pro{
            width: 426px;
            height: 16px;
            background: rgba(95, 169, 255, .15);
            border-radius: 16px;
            .currentPro{
              width: 426px;
              height: 16px;
              background: linear-gradient(90deg, #5FA9FF 0%, #3E81FF 100%);
              border-radius: 16px;
            }
          }
          .percentage{
            flex: 1;
            text-align: right;
            font-size: 28px;
            line-height: 62px;
            color: #333333;
          }
        }
        /deep/.van-collapse{
          .van-collapse-item{
            .van-cell{
              padding-left: 0;
              padding-right: 0;
              .van-cell__title{

              }
            }
            .van-collapse-item__wrapper{
              .van-collapse-item__content{
                padding-left: 0;
                padding-right: 0;
              }
            }
          }
        }
      }
      .section_02{
        margin-top: 40px;
        width: 100%;
        padding: 0 1px;
      }
      .section_03{
        .box{
          margin-bottom: 38px;
          &:last-child{
            margin-bottom: 0;
          }
          .box_content{
            padding: 40px 0 0;
            border-bottom: 0;
            top: 0;
            .top,.bottom{
              font-size: 24px;
              width: 100%;
              color: #333444;
              .left{
                float: left;
                margin-right: 12px;
                position: relative;
                .img{
                  width: 88px;
                  height: 88px;
                  display: inline-block;
                }
              }
              .right{
                height: 88px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-bottom: 20px;
                .text{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 6px;
                  .st2{
                    font-size: 24px;
                    color: #999AAA;
                  }
                }
                .info{
                  font-size: 24px;
                  color: #5FA9FF;
                  .text-overflow();
                }
              }
            }
            .top{
              margin-bottom: 40px;
              .box_item{
                .p_text{
                  margin-left: 100px;
                  padding-bottom: 40px;
                  font-weight: 400;
                  border-bottom: 1px solid #F0F0F0;
                }
              }
            }
          }
        }
      }
      /deep/.van-sticky--fixed{
        top: 69px;
      }
      .popup{
        margin-top: 60px;
        /deep/.van-cell{
          padding: 0 28px !important;
        }
        .title{
          padding: 18px 28px;
          margin-bottom: 24px;
          .left{
            display: flex;
            align-items: center;
            .icon{
              width: 36px;
              height: 36px;
              background-size: contain;
              background-repeat: no-repeat;
              &.icon_01{
                background-image: url('~@/assets/images/icon_checked_02.png');
              }
              &.icon_02{
                background-image: url('~@/assets/images/icon_checked_03.png');
              }
            }
            .name{
              margin-left: 10px;
            }
          }
        }
        .list{
          .list_content{
            .left{
              .icon{
                width: 36px;
                height: 36px;
                background-size: contain;
                background-repeat: no-repeat;
                &.icon_01{
                  background-image: url('~@/assets/images/icon_checked_02.png');
                }
                &.icon_02{
                  background-image: url('~@/assets/images/icon_checked_03.png');
                }
              }
            }
            &:last-child{
              margin-bottom: 24px;
            }
          }
        }
      }
    }

    .close{
      font-size: 32px;
      border-radius: 32px 32px 0px 0px;
      font-weight: bold;
      color: #333444;
      padding: 32px 30px;
      position: fixed;
      left: 0;
      right: 0;
      background-color: #fff;
      display: flex;
      height: 60px;
      justify-content: space-between;
      z-index: 9;
      align-items: center;
      .right{
        .img{
          width: 32px;
          height: 32px;
        }
      }
    }

    .fixed{
      margin: 0 auto;
      padding-top: 100px;
      padding: 12px 36px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: 999;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.04);
      .box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100px;
        .box_left{
          .list{
            display: flex;
            align-items: center;
            .list_item{
              display: flex;
              align-items: center;
              flex-direction: column;
              .icon{
                width: 32px;
                height: 32px;
                margin-bottom: 4px;
                background-image: url('~@/assets/images/book/icon_star_01.png');
                background-size: contain;
                &.active{
                  background-image: url('~@/assets/images/book/icon_star_02.png');
                }
              }
              .text{
                font-size: 20px;
                line-height: 28px;
                color: #333444;
              }
            }
          }
        }
        .box_right{
          .btn{
            width: 450px;
            border-radius: 44px;
            font-size: 26px;
            height: 76px;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            &.btn_01{
              background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
              box-shadow: 0px 6px 12px rgba(79, 157, 255, 0.16);
            }
            &.btn_02{
              background: linear-gradient(270deg, #FFAF19 0%, #FF7C36 100%);
              box-shadow: 0px 6px 20px rgba(255, 150, 46, 0.2);
            }
          }
        }
      }
      .popupFixed{
        .box_left{
          .fixBtnL{
            background: linear-gradient(270deg, #FFAF19 0%, #FF7C36 100%);
            box-shadow: 0px 6px 20px rgba(255, 150, 46, 0.2);
            border-radius: 44px;
            color: #FFFFFF;
            display: flex;
            height: 76px;
            align-items: center;
            justify-content: space-between;
            width: 386px;
            padding: 0 52px;
            .left{
              margin-right: 50px;
              .p{
                font-size: 26px;
              }
              .p2{
                font-size: 20px;
              }
            }
            .right{
              font-size: 32px;
              font-weight: bold;
            }
          }
        }
        .box_right{
          .fixBtnR{
            padding: 0 4px;
            min-width: 274px;
            background: #E8E8E8;
            border-radius: 44px;
            height: 76px;
            line-height: 76px;
            font-size: 26px;
            color: #333333;
            text-align: center;
            &.active{
              background: linear-gradient(88deg, #2E86FF 0%, #5FA9FF 100%);
              font-size: 30px;
              color: #FFFFFF;
            }
          }
        }
      }
    }
    .selectActive{
      background: #EFF6FF;
    }
  }
</style>
